export const generateAcronym = (text) => {
  if (!text) return '';
  
  // Split by spaces and special characters
  const words = text.split(/[\s-_]+/);
  
  // If it's a single word and longer than 3 characters, take first 3 letters
  if (words.length === 1) {
    return text.slice(0, 3).toUpperCase();
  }
  
  // For multiple words, take first letter of each word
  return words
    .map(word => word.charAt(0))
    .join('')
    .toUpperCase();
};

export const getProjectColor = (projectName) => {
  if (!projectName) return '#E8F0FE';

  // Extended set of color combinations
  const colorSets = [
    { bg: '#E8F0FE', border: '#D2E3FC', text: '#1A73E8' },  // Blue
    { bg: '#ECFDF5', border: '#D1FAE5', text: '#059669' },  // Green
    // { bg: '#FEF3C7', border: '#FDE68A', text: '#D97706' },  // Amber
    // { bg: '#F3E8FF', border: '#E9D5FF', text: '#7E22CE' },  // Purple
    { bg: '#FEE2E2', border: '#FECACA', text: '#DC2626' },  // Red
    { bg: '#E0F2FE', border: '#BAE6FD', text: '#0284C7' },  // Sky
    { bg: '#FCE7F3', border: '#FBCFE8', text: '#DB2777' },  // Pink
    { bg: '#F0FDF4', border: '#DCFCE7', text: '#16A34A' },  // Emerald
    { bg: '#FEF9C3', border: '#FEF08A', text: '#CA8A04' },  // Yellow
    { bg: '#F5F3FF', border: '#EDE9FE', text: '#6D28D9' },  // Indigo
    { bg: '#FFFBEB', border: '#FEF3C7', text: '#B45309' },  // Warm Yellow
    { bg: '#F0FDFA', border: '#CCFBF1', text: '#0D9488' },  // Teal
    { bg: '#FDF2F8', border: '#FCE7F3', text: '#BE185D' },  // Rose
    // { bg: '#F5F3FF', border: '#EDE9FE', text: '#5B21B6' },  // Violet
    { bg: '#ECFDF5', border: '#D1FAE5', text: '#047857' },  // Forest
    { bg: '#EFF6FF', border: '#DBEAFE', text: '#0369A1' },  // Ocean
    { bg: '#FDF4FF', border: '#FAE8FF', text: '#A21CAF' },  // Fuchsia
    { bg: '#F0FDFA', border: '#CCFBF1', text: '#0F766E' },  // Mint
    { bg: '#FEF2F2', border: '#FEE2E2', text: '#B91C1C' },  // Cherry
    { bg: '#F8FAFC', border: '#F1F5F9', text: '#0F172A' },  // Slate
  ];

  // Improved hash function
  const hash = projectName.split('').reduce((acc, char, index) => {
    // Use both character code and position in the string
    return char.charCodeAt(0) * (index + 1) + ((acc << 5) - acc);
  }, 0);

  // Get color set based on hash
  const colorIndex = Math.abs(hash) % colorSets.length;
  return colorSets[colorIndex];
};
